import { shape, string, func, bool } from "prop-types"
import { Box } from "@planningcenter/tapestry-react"

const QuestionDescription = ({ question, onDescriptionChanged, disabled }) => {
  return (
    <Box marginTop={2}>
      <label htmlFor="description">Description</label>
      <textarea
        name="description"
        id="description"
        value={question.description || ""}
        onChange={onDescriptionChanged}
        disabled={disabled}
      ></textarea>
    </Box>
  )
}

QuestionDescription.propTypes = {
  question: shape({ description: string }),
  onDescriptionChanged: func,
  disabled: bool
}

export default QuestionDescription
